import React, { FC, ReactNode, useEffect } from "react";
import { createPortal } from "react-dom";
import styles from "./Modal.module.scss";

interface ModalProps {
    isOpen: boolean;
    onClose: () => void;
    children: ReactNode;
    size?: "default" | "page" | "pageNarrow";
}

export const Modal: FC<ModalProps> = ({ isOpen, onClose, children, size = "default" }) => {
    useEffect(() => {
        if (!isOpen) return;

        const previousOverflow = document.body.style.overflow;
        document.body.style.overflow = "hidden";
        return () => {
            document.body.style.overflow = previousOverflow;
        };
    }, [isOpen]);

    if (!isOpen) return null;

    const modalRoot = document.getElementById("modal-root");
    if (!modalRoot) return null;

    const modalClassName = `${styles.modal}${size === "page" ? ` ${styles.modalPage}` : ""}${size === "pageNarrow" ? ` ${styles.modalPageNarrow}` : ""}`;

    return createPortal(
        <div className={styles.overlay} onClick={onClose}>
            <div className={modalClassName} onClick={(e) => e.stopPropagation()}>
                <button className={styles.closeBtn} onClick={onClose} aria-label="Close modal">
                    ×
                </button>
                <div className={styles.modalContent} data-modal-scroll-container="true">{children}</div>
            </div>
        </div>,
        modalRoot
    );
};
